import { useApp } from 'contexts/app';
import { createContext, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import chatService from 'services/chat';

const PageContext = createContext();

const PageProvider = (props) => {
    const { currentAssignmentId, currentAssignment, studentSubmissions } = useApp();
    const location = useLocation();
    const history = useHistory();

    const [viewFormativeDialog, setViewFormativeDialog] = useState({ open: false, submissionId: '' });
    const [feedbackInteractionsByDraft, setFeedbackInteractionsByDraft] = useState(null);

    const currentStudentSubmissions = useMemo(() => {
        const targetOwnerAccountId = new URLSearchParams(location.search).get('owner_account_id');
        return studentSubmissions?.filter(({ owner_account_id }) => owner_account_id === targetOwnerAccountId);
    }, [location.search, studentSubmissions]);

    const onClickBack = () => {
        const params = new URLSearchParams({ type: 'formative' });
        history.push(`/assignments/${currentAssignmentId}/submissions?${params.toString()}`);
    };

    const onClickViewSubmission = (submissionId) => {
        history.push(`/assignments/${currentAssignmentId}/submissions/${submissionId}`);
    };

    const onClickViewFormative = (submissionId) => {
        setViewFormativeDialog({ open: true, submissionId });
    };

    useEffect(() => {
        const targetOwnerAccountId = new URLSearchParams(location.search).get('owner_account_id');

        if (!currentAssignmentId || !targetOwnerAccountId || !currentAssignment?.course_id) {
            setFeedbackInteractionsByDraft(null);
            return;
        }

        let isMounted = true;

        const loadFeedbackInteractions = async () => {
            try {
                const feedbackInteractions = await chatService.getAssignmentChatStats({
                    active: true,
                    owner_account_id: targetOwnerAccountId,
                    course_id: currentAssignment.course_id,
                    assignment_id: currentAssignmentId,
                });

                if (!isMounted) return;
                setFeedbackInteractionsByDraft(feedbackInteractions ?? null);
            } catch (error) {
                if (!isMounted) return;
                console.error(error);
                setFeedbackInteractionsByDraft(null);
            }
        };

        loadFeedbackInteractions();

        return () => {
            isMounted = false;
        };
    }, [currentAssignment?.course_id, currentAssignmentId, location.search]);

    return (
        <PageContext.Provider
            value={{
                currentAssignment,
                currentStudentSubmissions,
                feedbackInteractionsByDraft,
                viewFormativeDialog,
                setViewFormativeDialog,

                onClickBack,
                onClickViewSubmission,
                onClickViewFormative,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
